export default "<p>master-acc works!</p>\n<router-outlet></router-outlet>\n";